/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type FreeTextbooksSubtopicViewFooterQueryVariables = {
    subtopicId: string;
};
export type FreeTextbooksSubtopicViewFooterQueryResponse = {
    readonly subtopic: {
        readonly id: string;
        readonly outcomes: ReadonlyArray<{
            readonly id: string;
            readonly code: string;
            readonly description: string;
        }>;
    } | null;
};
export type FreeTextbooksSubtopicViewFooterQuery = {
    readonly response: FreeTextbooksSubtopicViewFooterQueryResponse;
    readonly variables: FreeTextbooksSubtopicViewFooterQueryVariables;
};



/*
query FreeTextbooksSubtopicViewFooterQuery(
  $subtopicId: ID!
) {
  subtopic(id: $subtopicId) {
    id
    outcomes {
      id
      code
      description
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subtopicId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "subtopicId"
      }
    ],
    "concreteType": "FreeTextbookSubtopic",
    "kind": "LinkedField",
    "name": "subtopic",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Outcome",
        "kind": "LinkedField",
        "name": "outcomes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FreeTextbooksSubtopicViewFooterQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FreeTextbooksSubtopicViewFooterQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1d65cfc219ac3c08c0e19d799042ec9f",
    "id": null,
    "metadata": {},
    "name": "FreeTextbooksSubtopicViewFooterQuery",
    "operationKind": "query",
    "text": "query FreeTextbooksSubtopicViewFooterQuery(\n  $subtopicId: ID!\n) {\n  subtopic(id: $subtopicId) {\n    id\n    outcomes {\n      id\n      code\n      description\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '5638d64c58354ec51b971d0dd197316f';
export default node;
